<template>
  <div>
    <BProgress :id="invertersBarId"
               class="mt-2"
               :max="max">
      <BProgressBar class="inverters-bar-ok"
                    :value="invertersOk"></BProgressBar>
      <BProgressBar class="inverters-bar-warning"
                    :value="invertersMisproduction"></BProgressBar>
      <BProgressBar class="inverters-bar-danger"
                    :value="invertersFailed"></BProgressBar>
    </BProgress>
    <BPopover :target="invertersBarId"
              triggers="hover"
              placement="auto"
              :title="tr('performanceOverview.INVERTER_EVALUATION')">
      <template v-if="max > 0">
        <BListGroup>
          <BListGroupItem class="inverters-bar-ok border-0">
            {{ tr('performanceOverview.INVERTERS_OK') }}: {{ invertersOk }}
          </BListGroupItem>
          <BListGroupItem class="inverters-bar-warning border-0">
            {{ tr('performanceOverview.INVERTERS_MISPRODUCTION') }}: {{ invertersMisproduction }}
          </BListGroupItem>
          <BListGroupItem class="inverters-bar-danger border-0">
            {{ tr('performanceOverview.INVERTERS_FAILED') }}: {{ invertersFailed }}
          </BListGroupItem>
        </BListGroup>
      </template>
      <template v-else>
        {{ tr('performanceOverview.NO_INVERTER_EVALUATION') }}
      </template>
    </BPopover>
  </div>
</template>

<script>
  import { v4 as uuid } from 'uuid';
  import {
    BProgress, BProgressBar, BPopover, BListGroup, BListGroupItem,
  } from 'bootstrap-vue';
  import { translator } from '~/zf/frontend/common/mixins';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';

  export default {
    name: 'InvertersBar',
    compatConfig: {
      MODE: 3,
      COMPONENT_FUNCTIONAL: true,
      INSTANCE_EVENT_EMITTER: true,
    },
    components: {
      BProgress,
      BProgressBar,
      BPopover,
      BListGroup,
      BListGroupItem,
    },
    mixins: [translator],
    data() {
      return {
        BootstrapVariant,
        invertersOk: 0,
        invertersMisproduction: 0,
        invertersFailed: 0,
        max: 0,
        invertersBarId: `inverters-bar-${uuid()}`,
      };
    },
    beforeMount() {
      this.invertersOk = this.params.data.invertersOk;
      this.invertersMisproduction = this.params.data.invertersMisproduction;
      this.invertersFailed = this.params.data.invertersFailed;
      this.max = this.params.data.invertersOk + this.params.data.invertersMisproduction + this.params.data.invertersFailed;
    },
  };
</script>

<style lang="scss" scoped>
    .list-group-item,
    .progress-bar {
      &.inverters-bar-ok {
        background-color: $green-300;
        color: $gray-1100;
      }

      &.inverters-bar-warning {
        background-color: $orange-300;
        color: $gray-1100;
      }

      &.inverters-bar-danger {
        background-color: $orange-700;
        color: $gray-1100;
      }
    }

    .progress {
      background-color: $gray-945;
    }
</style>
